import * as types from './showPageActionTypes';

const setPagesPath = pages =>
  pages.map(page => {
    page.path = `/${page.pageNameC.replace(/\s/g, '').toLocaleLowerCase()}`;
    return page;
  });

export default (
  state = {
    pages: [],
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.GET_SHOW_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_SHOW_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        pages: setPagesPath(action.pages),
      };
    case types.GET_SHOW_PAGE_ERROR:
      return {
        ...state,
        pages: [],
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/showPage/showPageReducer.js